<template>
  <div :class="$style['pt-customer-table']">
      <wt-paged-table  :on-request-data="getTableData" :total-size="totalNumber"
      :page-size="pageSize" ref="table" :isAddPageToRouter="true" :isOutside="isOutside"
      :refresh="false">
          <wt-table :labels="tableLabels" :list="tableData">
              <el-table-column v-if="showRadio" slot="before" label="" width="50">
                <template  slot-scope="scope">
                    <el-radio v-model="selectId" :label="scope.row.id" :class="$style['meal-list-radio']" @change="selectMealRow(scope.row)"></el-radio>
                </template>
              </el-table-column>
              <slot/>
          </wt-table>
    </wt-paged-table>
  </div>
</template>

<script>
// 组件class前缀
const prefixCls = 'pt-customer-table'

export default {
  name: 'pt-customer-table',
  computed: {
    classes () {
      return `${prefixCls}`
    },
    page () {
      return this.$refs.table.page
    }
  },
  props: {
    totalNumber: {
      type: Number,
      default: 0
    },
    pageSize: {
      type: Number,
      default: 10
    },
    isOutside: {
      type: Boolean,
      default: false
    },
    tableLabels: {
      type: Array,
      default: function () {
        return []
      }
    },
    tableData: {
      type: Array,
      default: function () {
        return []
      }
    },
    showRadio: {
      type: Boolean,
      default: false
    },
    selectedKeys: {
      type: String,
      default: ''
    },
  },
  data(){
    return{
      selectId:this.selectedKeys || ''
    }
  },
  methods: {
    selectMealRow (data) {
      this.$emit('updateSelectData', data)
    },
    getTableData (page, next) {
      this.$emit('getTableData', page, next)
    },
    resetPage () {
      this.$refs.table.resetPage()
    },
    reload () {
      this.$refs.table.load()
    },
    showReTry(){
      this.$refs.table.showReTry()
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
</style>
